import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { BaseGlobalErrorHandler } from './core/error-handler/base-global-error.handler';
import { BaseAuthInterceptor } from './core/interceptors/base-auth.interceptor';
import { BaseHttpErrorsInterceptor } from './core/interceptors/base-http-errors.interceptor';
import { BaseSpinnerInterceptor } from './core/interceptors/base-spinner.interceptor';
import { BaseAcceptLanguageInterceptor } from './core/interceptors/base-accept-language.interceptor';
import { BaseSharedStoreModule } from './modules/shared/base-shared-access-data.service';
import { BaseAuthStoreModule } from './modules/auth/base-auth-store.module';
import { BaseDashboardStoreModule } from './modules/dashboard/base-dashboard-store.module';
import { BaseOffersAndBookingsStoreModule } from './modules/offers-and-bookings/base-offers-and-bookings-store.module';
import { BaseAdministrationStoreModule } from './modules/administration/base-administration-store.module';
import { BasePspBranchStoreModule } from './modules/psp-branch/base-psp-branch-store.module';
import { BaseUsersStoreModule } from './modules/users/base-users-store.module';
import { BaseDocumentsStoreModule } from './modules/documents/base-documents-store.module';
import { BaseCandidatesStoreModule } from './modules/candidates/base-candidates-store.module';
import { BaseInquiryStoreModule } from './modules/inquiry/base-inquiry-store.module';
import { BaseRelatedPspBranchesStoreModule } from './modules/related-psp-branches/base-related-psp-branches-store.module';
import { BasePlanningBoardStoreModule } from './modules/planning-board/base-planning-board-store.module';
import { BaseTimeRecordingsStoreModule } from './modules/time-recordings/base-time-recordings-store.module';
import { FrontendPathInterceptor } from './core/interceptors/frontend-path.interceptor';

@NgModule({
  imports: [
    NgxPermissionsModule.forRoot(),
    BaseSharedStoreModule,
    BaseAuthStoreModule,
    BaseDashboardStoreModule,
    BaseOffersAndBookingsStoreModule,
    BaseAdministrationStoreModule,
    BasePspBranchStoreModule,
    BaseUsersStoreModule,
    BaseDocumentsStoreModule,
    BaseCandidatesStoreModule,
    BaseInquiryStoreModule,
    BaseRelatedPspBranchesStoreModule,
    BasePlanningBoardStoreModule,
    BaseTimeRecordingsStoreModule,
  ],
  providers: [
    { provide: ErrorHandler, useClass: BaseGlobalErrorHandler },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: BaseAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: BaseAcceptLanguageInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: BaseHttpErrorsInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: BaseSpinnerInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: FrontendPathInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class BaseModule {}
